var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dialog',{attrs:{"dialog":_vm.isError(),"bodyText":_vm.getMessage(),"isDisplayCancel":false,"title":_vm.dialogTitle,"buttonTextOK":_vm.getButtonText()},on:{"confirmOpratipon":_vm.confirmOpratipon}})}
var staticRenderFns = []

export { render, staticRenderFns }